import { Typography } from "antd";
import { useEffect, useState } from "react";

import { BTExternalLink } from "commonComponents/btWrappers/BTExternalLink/BTExternalLink";
import { BTQRCode } from "commonComponents/utilities/BTQRCode/BTQRCode";

interface IImpersonationQRContentProps {
    url: string;
    name: string;
    expiresInMinutes: number;
}

type CopyStatus = "copied" | "failed" | "pending";

const ImpersonationQRContent = ({ url, name, expiresInMinutes }: IImpersonationQRContentProps) => {
    const [copyStatus, setCopyStatus] = useState<CopyStatus>("pending");

    useEffect(() => {
        if (!navigator.clipboard?.writeText) {
            setCopyStatus("failed");
            return;
        }
        navigator.clipboard.writeText(url).then(
            () => setCopyStatus("copied"),
            () => setCopyStatus("failed"),
        );
    }, [url]);

    return (
        <div style={{ textAlign: "center" }}>
            <div style={{ fontWeight: 500, marginBottom: 12 }}>
                Scan the QR code or share the link below to log in as {name}.
            </div>
            <BTQRCode value={url} width={200} height={200} />
            <div style={{ marginTop: 12 }}>
                <BTExternalLink href={url} isUnderline={true}>
                    {url}
                </BTExternalLink>
            </div>
            <div style={{ marginTop: 6 }}>
                {copyStatus === "copied" && (
                    <Typography.Text type="success">✓ Link copied to clipboard</Typography.Text>
                )}
                {copyStatus === "failed" && (
                    <Typography.Text type="warning">
                        Could not copy automatically — copy the link above
                    </Typography.Text>
                )}
            </div>
            <div style={{ marginTop: 8, color: "#666" }}>
                This link expires in {expiresInMinutes} minute{expiresInMinutes !== 1 ? "s" : ""} or
                after one use.
            </div>
        </div>
    );
};

export default ImpersonationQRContent;
